module.exports = __webpack_public_path__ + "files/SPIADI2026 - EXP ADI - Tableau Exp-Néo.49e93338dd92a961b424806ac1e91e4a.pdf";